import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';

const HowToUseMagnus =() => {
    return(
      <>
     <Breadcrumb />
      <Typography>
         HowToUseMagnus works
       </Typography>
       </>
       );
};

export default HowToUseMagnus;
